import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  /* Import HGAlmond font */
  @font-face {
    font-family: "HGAlmond 80g";
    src: url(https://framerusercontent.com/assets/yvxpvPBJIq9EC9Tf0KpNnX7Mckg.woff2);
    font-display: swap;
  }
  /* Reset and base styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  html, body, #root {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6, p, figure {
    margin: 0;
  }

  body {
    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
    background: #21004D;
    color: white;
    min-height: 100vh;
    font-feature-settings: 'kern' 1;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
  }

  /* Container utility */
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 32px;

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }

  /* Legacy classes for sections not yet converted */
  .highlight {
    color: #EBB800;
    background: linear-gradient(135deg, #EBB800 0%, #FFD700 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .highlight-orange {
    color: #FF6B35;
    background: linear-gradient(135deg, #FF6B35 0%, #FF8A65 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  /* Problem Section Styles */
  .problem-section {
    padding: 120px 0;
    background: #1a0039;
    position: relative;
  }

  .problem-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 32px;

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }

  .problems-grid {
    margin-top: 60px;
  }

  .problem-scroll-wrapper {
    display: flex;
    flex-direction: column;
    gap: 60px;
  }

  .problem-item {
    .problem-image {
      position: relative;
      border-radius: 20px;
      overflow: hidden;
      height: 350px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .problem-content {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
        padding: 40px 30px 30px;
        color: white;

        h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 15px;
          line-height: 1.3;
        }

        p {
          color: rgba(255, 255, 255, 0.9);
          line-height: 1.6;
        }
      }
    }
  }

  /* Solution2 Section */
  .solution2-section {
    padding: 120px 0;
    background: #21004D;

    .solution2-header {
      text-align: center;
      margin-bottom: 80px;

      .solution2-badge {
        display: inline-block;
        background: rgba(235, 184, 0, 0.2);
        color: #EBB800;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 20px;
        border: 1px solid rgba(235, 184, 0, 0.3);
      }

      h2 {
        font-size: 2.5rem;
        font-weight: 800;
        line-height: 1.3;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
    }

    .solution2-content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
      gap: 60px;
      margin-top: 80px;

      @media (max-width: 1400px) {
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 40px;
      }
    }

    .solution2-item {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 20px;
      padding: 40px;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s ease;
      opacity: 0;
      transform: translateY(30px);

      &.active {
        opacity: 1;
        transform: translateY(0);
      }

      &:hover {
        transform: translateY(-5px);
        border-color: rgba(235, 184, 0, 0.3);
      }

      .item-image {
        margin-bottom: 30px;
        border-radius: 15px;
        overflow: hidden;

        img {
          width: 100%;
          height: 200px;
          object-fit: contain;
        }
      }

      h3 {
        font-size: 1.5rem;
        font-weight: 700;
        margin-bottom: 15px;
        color: #EBB800;
      }

      p {
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.6;
      }
    }
  }

  /* Solution3 Section */
  .solution3-section {
    padding: 120px 0;
    background: #1a0039;

    .solution3-header {
      text-align: center;
      margin-bottom: 80px;

      .solution3-badge {
        display: inline-block;
        background: rgba(235, 184, 0, 0.2);
        color: #EBB800;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 20px;
        border: 1px solid rgba(235, 184, 0, 0.3);
      }

      h2 {
        font-size: 2.5rem;
        font-weight: 800;
        line-height: 1.3;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
    }

    .solution3-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 80px;
      align-items: center;
      margin-top: 60px;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 60px;
      }

      .solution3-left {
        .solution3-image {
          border-radius: 20px;
          overflow: hidden;

          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }

        &.active {
          animation: fadeInLeft 0.8s ease;
        }
      }

      .solution3-right {
        h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 30px;
          color: #EBB800;
        }

        p {
          font-size: 1.1rem;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.8;
        }

        &.active {
          animation: fadeInRight 0.8s ease;
        }
      }
    }
  }

  /* Benefits Section */
  .benefits-section {
    padding: 120px 0;
    background: linear-gradient(135deg, #21004D 0%, #3D0066 100%);

    .benefits-header {
      text-align: center;
      margin-bottom: 80px;

      h2 {
        font-size: 2.5rem;
        font-weight: 800;
        line-height: 1.3;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
    }
  }

  /* Certification Section */
  .certification-section {
    padding: 120px 0;
    background: #21004D;

    .certification-header {
      text-align: center;
      margin-bottom: 80px;

      h2 {
        font-size: 2.5rem;
        font-weight: 800;
        line-height: 1.3;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
    }

    .certification-carousel-wrapper {
      overflow: hidden;
      margin-top: 60px;
    }

    .certification-carousel {
      .certification-track {
        display: flex;
        gap: 30px;
        animation: scroll 30s linear infinite;

        .certification-item {
          flex-shrink: 0;
          width: 300px;
          height: 400px;
          border-radius: 15px;
          overflow: hidden;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }

  /* Promotion Section */
  .promotion-section {
    padding: 120px 0;
    background: #1a0039;

    .promotion-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 80px;
      align-items: center;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 60px;
        text-align: center;
      }

      .promotion-left {
        h2 {
          font-size: 2.5rem;
          font-weight: 800;
          line-height: 1.3;

          @media (max-width: 768px) {
            font-size: 2rem;
          }
        }
      }

      .promotion-right {
        display: flex;
        justify-content: center;

        .promotion-banner {
          .sale-image {
            max-width: 300px;
            width: 100%;
            height: auto;
            transition: transform 0.3s ease;

            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }

  /* Media Section */
  .media-section {
    padding: 120px 0;
    background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('../images/media.png');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    color: white;
    text-align: center;

    .media-content {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 20px;
    }

    .media-text {
      h2 {
        font-size: 2.5rem;
        font-weight: 800;
        margin-bottom: 20px;
        line-height: 1.3;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }

      .media-subtitle {
        font-size: 1.2rem;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 30px;
      }
    }
  }

  /* Final CTA Section */
  .final-cta-section {
    padding: 120px 0;
    background: #1a0039;

    .final-cta-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 80px;
      align-items: center;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 60px;
        text-align: center;
      }

      .final-cta-left {
        h2 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 20px;
          line-height: 1.3;

          @media (max-width: 768px) {
            font-size: 2rem;
          }
        }

        p {
          font-size: 1.1rem;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
        }
      }

      .final-cta-right {
        .simple-contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;

          .form-field {
            display: flex;
            flex-direction: column;
            gap: 8px;

            label {
              color: rgba(255, 255, 255, 0.9);
              font-weight: 500;
              font-size: 14px;
            }

            input {
              padding: 16px 20px;
              border: 1px solid rgba(255, 255, 255, 0.2);
              border-radius: 10px;
              background: rgba(255, 255, 255, 0.05);
              color: white;
              font-size: 16px;
              transition: all 0.3s ease;

              &::placeholder {
                color: rgba(255, 255, 255, 0.5);
              }

              &:focus {
                outline: none;
                border-color: #EBB800;
                box-shadow: 0 0 0 3px rgba(235, 184, 0, 0.1);
              }
            }
          }

          .submit-btn {
            padding: 16px 32px;
            background: linear-gradient(135deg, #EBB800 0%, #FFD700 100%);
            color: #21004D;
            border: none;
            border-radius: 10px;
            font-weight: 700;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s ease;
            margin-top: 10px;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 8px 25px rgba(235, 184, 0, 0.3);
            }

            &:disabled {
              opacity: 0.7;
              cursor: not-allowed;
              transform: none;
            }
          }
        }
      }
    }
  }

  /* News Page Styles */
  .hero {
    padding: 120px 0 80px;
    background: linear-gradient(135deg, #21004D 0%, #3D0066 100%);
    text-align: center;

    h1 {
      font-size: 3rem;
      font-weight: 800;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        font-size: 2.5rem;
      }
    }

    p {
      font-size: 1.2rem;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .featured-news, .recent-articles {
    padding: 80px 0;
    background: #1a0039;

    .section-badge {
      display: inline-block;
      background: rgba(235, 184, 0, 0.2);
      color: #EBB800;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 40px;
      border: 1px solid rgba(235, 184, 0, 0.3);
    }

    .featured-article {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 60px;
      align-items: center;
      text-decoration: none;
      color: inherit;
      border-radius: 20px;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.05);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(235, 184, 0, 0.2);
      }

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
      }

      .featured-image img {
        width: 100%;
        height: 300px;
        object-fit: contain;
      }

      .featured-content {
        padding: 40px;

        h2 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #EBB800;
        }

        p {
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .featured-meta {
          display: flex;
          gap: 15px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }

    .articles-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      gap: 40px;
      margin-top: 60px;

      @media (max-width: 1400px) {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
        margin-top: 40px;
      }
    }

    .article-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 15px;
      overflow: hidden;
      text-decoration: none;
      color: inherit;
      transition: all 0.3s ease;

              &:hover {
          transform: translateY(-5px);
        }

      .article-image img {
        width: 100%;
        height: 200px;
        object-fit: contain;
      }

      .article-content {
        padding: 25px;

        h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 15px;
          line-height: 1.4;
        }

        .article-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }

  /* Blog Page Styles */
  .featured-blog {
    padding: 80px 0;
    background: #1a0039;
  }

  .newsletter {
    padding: 80px 0;
    background: #21004D;

    .newsletter-content {
      text-align: center;
      max-width: 600px;
      margin: 0 auto;

      h3 {
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 15px;
        color: #EBB800;
      }

      p {
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 30px;
      }

      .newsletter-form {
        display: flex;
        gap: 15px;
        max-width: 400px;
        margin: 0 auto;

        @media (max-width: 480px) {
          flex-direction: column;
        }

        input {
          flex: 1;
          padding: 15px 20px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.05);
          color: white;
          font-size: 16px;

          &::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }

          &:focus {
            outline: none;
            border-color: #EBB800;
          }
        }

        button {
          padding: 15px 25px;
          background: linear-gradient(135deg, #EBB800 0%, #FFD700 100%);
          color: #21004D;
          border: none;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(235, 184, 0, 0.3);
          }
        }
      }
    }
  }

  /* Pricing Page Styles */
  .pricing {
    padding: 80px 0;
    background: #1a0039;

    .pricing-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
      gap: 40px;
      margin-top: 80px;

      @media (max-width: 1400px) {
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 30px;
        margin-top: 60px;
      }
    }

    .pricing-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 20px;
      padding: 40px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s ease;

      &.featured {
        transform: scale(1.05);
        border-color: #EBB800;
        background: rgba(235, 184, 0, 0.1);
      }

      &:hover {
        transform: translateY(-5px);
      }

      .plan-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;

        .plan-badge {
          background: #EBB800;
          color: #21004D;
          padding: 8px 16px;
          border-radius: 15px;
          font-weight: 600;
          font-size: 14px;
        }

        .plan-yearly {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
        }
      }

      .plan-price {
        font-size: 3rem;
        font-weight: 800;
        color: #EBB800;
        margin-bottom: 30px;

        .plan-unit {
          font-size: 1.5rem;
          color: rgba(255, 255, 255, 0.7);
        }
      }

      .plan-features {
        list-style: none;
        margin-bottom: 40px;

        li {
          padding: 10px 0;
          color: rgba(255, 255, 255, 0.8);
          position: relative;
          padding-left: 25px;

          &::before {
            content: '✓';
            position: absolute;
            left: 0;
            color: #EBB800;
            font-weight: bold;
          }
        }
      }

      .plan-button {
        width: 100%;
        padding: 15px;
        background: linear-gradient(135deg, #EBB800 0%, #FFD700 100%);
        color: #21004D;
        border: none;
        border-radius: 10px;
        font-weight: 700;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
        }
      }
    }
  }

  .promotion {
    padding: 80px 0;
    background: #21004D;

    .promotion-title {
      text-align: center;
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 60px;
      color: #EBB800;
    }

    .promotion-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
      gap: 40px;
    }

    .promotion-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 20px;
      padding: 40px;
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      .promotion-badge {
        background: #EBB800;
        color: #21004D;
        padding: 10px 20px;
        border-radius: 20px;
        font-weight: 600;
        margin-bottom: 30px;
        display: inline-block;
      }

      .promotion-text {
        margin-bottom: 30px;

        .promotion-year {
          font-size: 1.2rem;
          margin-bottom: 10px;
        }

        .promotion-condition {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 5px;
        }

        .promotion-discount {
          font-size: 1.5rem;
          font-weight: 700;
          color: #EBB800;
          margin-top: 15px;
        }
      }

      .promotion-image img {
        border-radius: 15px;
      }
    }
  }

  .cx-section {
    padding: 80px 0;
    background: #1a0039;

    .cx-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 80px;
      align-items: center;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 60px;
      }

      .cx-left {
        .cx-badge {
          background: rgba(235, 184, 0, 0.2);
          color: #EBB800;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 20px;
          display: inline-block;
          border: 1px solid rgba(235, 184, 0, 0.3);
        }

        .cx-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          line-height: 1.3;

          .cx-highlight {
            color: #EBB800;
          }
        }

        .cx-stats {
          display: flex;
          flex-direction: column;
          gap: 30px;

          .cx-stat {
            display: flex;
            align-items: center;
            gap: 20px;

            .cx-number {
              font-size: 3rem;
              font-weight: 800;
              color: #EBB800;
              min-width: 100px;
            }

            .cx-label {
              color: rgba(255, 255, 255, 0.8);
              line-height: 1.5;
            }
          }
        }
      }

      .cx-right {
        display: flex;
        justify-content: center;

        .cx-thumbs {
          .thumb-container {
            .thumb-image {
              max-width: 300px;
              width: 100%;
              height: auto;
              border-radius: 20px;
            }
          }
        }
      }
    }
  }

  .testimonials {
    padding: 80px 0;
    background: #21004D;

    .testimonial-header {
      text-align: center;
      margin-bottom: 60px;

      .testimonial-badge {
        display: inline-block;
        background: rgba(235, 184, 0, 0.2);
        color: #EBB800;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 20px;
        border: 1px solid rgba(235, 184, 0, 0.3);
      }

      .testimonials-title {
        font-size: 2.5rem;
        font-weight: 800;
        line-height: 1.3;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
    }

    .testimonials-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 30px;
    }

    .testimonial-card {
      border-radius: 15px;
      overflow: hidden;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }

      .testimonial-image {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .contact {
    padding: 80px 0;
    background: #1a0039;

    .contact-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 80px;
      align-items: center;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 60px;
      }

      .contact-text {
        h2 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 20px;
          line-height: 1.3;

          @media (max-width: 768px) {
            font-size: 2rem;
          }
        }

        p {
          font-size: 1.1rem;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
        }
      }

      .contact-form {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;

          label {
            color: rgba(255, 255, 255, 0.9);
            font-weight: 500;
            font-size: 14px;
          }

          input {
            padding: 16px 20px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 10px;
            background: rgba(255, 255, 255, 0.05);
            color: white;
            font-size: 16px;
            transition: all 0.3s ease;

            &::placeholder {
              color: rgba(255, 255, 255, 0.5);
            }

            &:focus {
              outline: none;
              border-color: #EBB800;
              box-shadow: 0 0 0 3px rgba(235, 184, 0, 0.1);
            }
          }
        }

        .submit-button {
          padding: 16px 32px;
          background: linear-gradient(135deg, #EBB800 0%, #FFD700 100%);
          color: #21004D;
          border: none;
          border-radius: 10px;
          font-weight: 700;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 10px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(235, 184, 0, 0.3);
          }

          &:disabled {
            opacity: 0.7;
            cursor: not-allowed;
            transform: none;
          }
        }
      }
    }
  }

  /* Switch component styles */
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: .4s;
      border-radius: 34px;

      &:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: .4s;
        border-radius: 50%;
      }
    }

    input:checked + .slider {
      background-color: #EBB800;
    }

    input:checked + .slider:before {
      transform: translateX(26px);
    }
  }

  /* Animations */
  @keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* Responsive breakpoints */
  @media(min-width: 1400px) {
    .hidden-y59dwl { display: none !important; }
  }
  
  @media(min-width: 810px) and (max-width: 1399px) {
    .hidden-1g3lkei { display: none !important; }
  }
  
  @media(max-width: 809px) {
    .hidden-e05re9 { display: none !important; }
  }
`;